// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"96":"vendors","524":"app"}[chunkId] + "." + {"96":"10d49dca08623386e2d3","524":"cda8e3bbe869b32db99c"}[chunkId] + ".chunk.bundle.js";
};